export const WizardPageWidgetId = 'WizardPageWidget';

export enum WizardPageWidgetAttributes {
  TITLE = 'title',
  WIDGETS = 'widgets',
  NEXT_BUTTON_TEXT = 'nextButtonText',
}
